import { makeStyles } from '@alpha/ui-lib/theme';

const BREAKPOINT_WIDTH = 1000;

export const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    backgroundColor: '#3D1629',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '24px',
    overflow: 'hidden',
    marginBottom: '16px',
    [`@media (max-width: ${BREAKPOINT_WIDTH}px)`]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  imageWrapper: {
    position: 'relative',
    zIndex: 2,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    [`@media (max-width: ${BREAKPOINT_WIDTH}px)`]: {
      justifyContent: 'center',
    },
  },
  logo: {
    height: '56px',
  },
  backgroundImage: {
    position: 'absolute',
    right: '24px',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1,
  },
  buttonsWrapper: {
    marginLeft: 'auto',
    maxWidth: '436px',
    zIndex: 3,
    position: 'relative' as const,
    [`@media (max-width: ${BREAKPOINT_WIDTH}px)`]: {
      marginLeft: 0,
      marginTop: '16px',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      maxWidth: '100%',
    },
  },
  primaryButton: {
    zIndex: 3,
    position: 'relative' as const,
    height: '44px',
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    border: 'none',
    padding: '0 16px',
    cursor: 'pointer',
  },
  secondaryButton: {
    zIndex: 3,
    position: 'relative' as const,
    marginLeft: '8px',
    height: '44px',
    backgroundColor: '#FFFFFF26',
    borderRadius: '10px',
    border: '1px solid #FFFFFF',
    padding: '0 16px',
    cursor: 'pointer',
    color: '#FFFFFF',
    [`@media (max-width: ${BREAKPOINT_WIDTH}px)`]: {
      marginLeft: '8px',
    },
  },
}));

export default useStyles;
